import { useState, useEffect, useCallback } from "react";
import {
  collection, getDocs, addDoc, deleteDoc, doc,
  query, orderBy, where,
} from "../services/firebase";

export function useCommunity(fbDb) {
  const [communityTrips, setCommunityTrips] = useState([]);
  const [communityLoaded, setCommunityLoaded] = useState(false);
  const [viewingCommunityTrip, setViewingCommunityTrip] = useState(null);

  const loadCommunityTrips = useCallback(async () => {
    if (!fbDb) return;
    try {
      const qy = query(collection(fbDb, "community"), orderBy("sharedAt", "desc"));
      const snap = await getDocs(qy);
      setCommunityTrips(snap.docs.map(d => ({ _docId: d.id, ...d.data() })));
      setCommunityLoaded(true);
    } catch (e) {
      console.warn("커뮤니티 로드 실패:", e);
    }
  }, [fbDb]);

  useEffect(() => { loadCommunityTrips(); }, [loadCommunityTrips]);

  const shareToCommunity = useCallback(async (trip) => {
    if (!fbDb) return;
    try {
      await addDoc(collection(fbDb, "community"), {
        ...trip, sharedAt: Date.now(),
      });
      setCommunityLoaded(false);
    } catch (e) {
      console.error("커뮤니티 공유 실패:", e);
    }
  }, [fbDb]);

  const deleteCommunityTrip = useCallback(async (tripIdOrIdx) => {
    if (!fbDb) return;
    const target = communityTrips.find((tr, i) => (tr._docId || String(i)) === String(tripIdOrIdx));
    if (target?._docId) {
      try { await deleteDoc(doc(fbDb, "community", target._docId)); } catch (e) {}
    }
    setCommunityTrips(prev => prev.filter((tr, i) => (tr._docId || String(i)) !== String(tripIdOrIdx)));
  }, [fbDb, communityTrips]);

  return {
    communityTrips, setCommunityTrips, communityLoaded, setCommunityLoaded,
    viewingCommunityTrip, setViewingCommunityTrip,
    shareToCommunity, deleteCommunityTrip, loadCommunityTrips,
  };
}
